<template>

<app-view-list-field align="center" :is-condensed="isCondensed" :is-sticky="isSticky" :field="field" :filter="filter">

    <core-rating :value="value" :count="count" :showIndividualRatings="true" :ratings="item.users.rated" class="rating" v-on:more="onClick" />

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isCondensed', 'isSticky'],

	computed: {

		value: function() {

			return this.item.group.rating_avg

		},

		count: function() {

			return this.item.group.rating_count

		}

	},

	methods: {

		onClick: function() {

			this.$pubsub.$emit('expand.open', {
				id: this.item.game.id,
				section: 'ratings'
			})

		}

	}

}

</script>

<style scoped>

.rating {
    width: 48px;
    height: 48px;
    line-height: 48px;
}

.field.is-condensed .rating {
    height: 24px;
    line-height: 24px;
    font-size: 14px;
}

</style>